$(function () {
    let tab = $('.mdc-tab-bar');

    if (tab.length > 0) {
        tab[0].MDCTabBar.listen('MDCTabBar:activated', function () {
            window.themeS.data('theme-color', getActiveTab().data('theme-color'));
            window.themeS.data('theme-icon', getActiveTab().data('theme-icon'));
            window.themeS.data('cate-id', getActiveTab().data('cate-id'));
            window.themeS.data('zone-id', getActiveTab().data('zone-id'));

            themeChanged();
        });
    }

    initMasonry();

    function initMasonry() {
        let cate = getActiveTab().data('cate-id');
        let term = $('.search-term').data('term');

        if (term) {
            window.vm.$refs.builder.initRequest = `/popsale/api/v1/offer/search?term=${term}&ads=1`;
        } else {
            window.vm.$refs.builder.initRequest = `/popsale/api/v1/offer/search?cat=${cate}&ads=1`;
            themeChanged();
        }
    }
});